import { FC } from 'react';
import {
  ShiftPostsVariant,
  STEPS,
} from 'app/modules/posts/hooks/useShiftPosts';
import { Button, Icon } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';
import Modal from 'components/shared/Modal';

type Props = {
  onGoNext: () => void;
  activeStep: number;
  canGoNext: boolean;
  onSubmit: () => void;
  variant: ShiftPostsVariant;
};

const Footer: FC<Props> = ({
  onGoNext,
  activeStep,
  canGoNext,
  onSubmit,
  variant,
}) => {
  const { t } = useTranslation();
  if (activeStep === STEPS.SELECT_POSTS.step) {
    return (
      <Modal.Footer>
        <Button
          key="next-step"
          onClick={onGoNext}
          disabled={!canGoNext}
          iconAfter={<Icon icon={faArrowRight} />}
          data-name={`workflow-options-dropdown_${variant}-posts_next-step`}
          data-cy={`workflow-options-dropdown_${variant}-posts_next-step`}
        >
          {t('postsShift.nextStep')}
        </Button>
      </Modal.Footer>
    );
  }

  if (activeStep === STEPS.RESULTS.step) {
    return (
      <Modal.Footer>
        <Button
          onClick={onGoNext}
          data-name={`workflow-options-dropdown_${variant}-posts_close`}
        >
          {t('close')}
        </Button>
      </Modal.Footer>
    );
  }

  return (
    <Modal.Footer>
      <Button
        onClick={onSubmit}
        data-name={`workflow-options-dropdown_${variant}-posts_confirm`}
        data-cy={`workflow-options-dropdown_${variant}-posts_confirm`}
      >
        {variant === 'duplicate' ? t('duplicatePosts') : t('movePosts')}
      </Button>
    </Modal.Footer>
  );
};

export default Footer;
